import { useEngineRules } from '../hooks/useEngineRules'

/** "Oct 15, 2026 00:00 UTC": always the time and zone, never a bare date. */
export const formatLevelExitsFrom = (iso: string): string | null => {
  const withZone = /(Z|[+-]\d{2}:?\d{2})$/.test(iso) ? iso : `${iso}Z`
  const date = new Date(withZone)
  if (Number.isNaN(date.getTime())) return null
  const day = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
  return `${day} ${date.toISOString().slice(11, 16)} UTC`
}

/**
 * The dated note on how stop and target closes are scored, shown wherever
 * results are listed. Only once LEVEL_EXITS_FROM is set (from
 * /api/public/engine-rules): until then every close is scored the old way
 * and there is nothing to date.
 */
const LevelExitsNote = ({ className = '' }: { className?: string }) => {
  const rules = useEngineRules()
  const from = rules?.level_exits_from ? formatLevelExitsFrom(rules.level_exits_from) : null
  if (!from) return null
  return (
    <p className={`text-xs text-gray-500 ${className}`} data-testid="level-exits-note">
      From {from}, stops and targets are scored at the level (or the opening price if price gapped past it), using
      1-minute prices. Earlier closes are scored at the next 5-minute price check and are shown exactly as recorded.
    </p>
  )
}

export default LevelExitsNote
